import { Picture } from 'react-responsive-picture';
import React from "react";
import MobileLogo from "site_media/images/Logo_Cappy_Freefalling.png";
import DesktopLogo from "site_media/images/Logo_Cappy_Freefalling.png";
import "components/Account/Onboarding/OnboardingBannerImage.css";
import RoundedButton from "../../General/Form/CustomButton/RoundedButton";
import {withRouter} from "react-router-dom";

class OnboardingBannerImage extends React.Component {

    onLogoutClicked(event) {
        this.props.history.push(`/logout`);
    }
    render() {
        return (
            <div className="unregister-banner">
                <Picture
                    id="unregister-banner-image"
                    className="unregister-banner-image"
                    sources={[
                        {
                            srcSet: MobileLogo,
                            media: "(max-width: 10px)",
                        },
                        {
                            srcSet: DesktopLogo,
                        }
                    ]}
                />
                <RoundedButton
                    id="Login"
                    title="LOGOUT"
                    buttonClassName="background_dark_blue login-button"
                    textThemeClassName="text_small text_white"
                    handleOnClick={this.onLogoutClicked.bind(this)}
                />
            </div>
        );
    }
}

export default withRouter (OnboardingBannerImage);